import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { MapService } from 'src/app/Services/map.service';
import { RouteService } from 'src/app/Services/route.service';
import { StorageService } from 'src/app/Services/storage.service';
declare var google: any;

@Component({
  selector: 'g10-roster-dashboard-map',
  templateUrl: './roster-dashboard-map.component.html',
  styleUrls: ['./roster-dashboard-map.component.css']
})
export class RosterDashboardMapComponent implements OnInit {
  public tableData:any={};
  public finalTableData:any={};
  public responseData:any=[];
  public shiftList:any=[];
  public vehicleList:any=[];
  public employeeList:any=[];
  public routeId:any;
  public shiftInformation:any=[];
  public rosterMapHeight:string='100%';
  public selectedMap:string='openStreet';
  public googleMapObj:any;
  public globalGoogleMarker:any=[];
  public gglEmpMarker:any;
  public routePath:any;
  public leastShiftTime:number;
  public selectedShift:string='';
  public selectedVehicle:string='';
  public selectedEmployee:string='';
  public selectedTrinsitMode:string='Pickup';
  public showNoData:boolean=false;
  public showEmpDetail:boolean=false;
  public selectedEmpDetails:any;
  public vehiclesArr:any=[];

  public availableShifts:any=[];
  //OSRM map
  public primaryMap: any;
  public osrmMarkers:any=[];
  public osrmEmpMarker:any;
  public osrmMarkerInfoStyle = 'hidden';
  public isSingleEmpShow:boolean=false;

  //Distance
  public totalDistance:number=0;
  constructor(
    public api:ApiService,
    public storage:StorageService,
    private routeservice: RouteService,
    public mapService: MapService,
    public com: CommonServices
  ) {
      let user = this.storage.get('userInfo');
      if(user && user.map){
        this.selectedMap = user.map;
      }
  }

  ngOnInit(): void {
    this.loadMap();
    setTimeout(()=>{
      this.getRouteList('Pickup');
    },2000)
  }
  loadMap(){
    if(this.selectedMap=='google'){
      setTimeout(()=>{
        const mapOptions = {
          scrollwheel: true,
          zoom: 10,
          maxZoom: 17,
          center: new google.maps.LatLng(13.1031,80.1794),
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
          },
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_CENTER,
          },
          streetViewControl: false,
        };
        this.googleMapObj = new google.maps.Map(document.getElementById('rosterMap'), mapOptions);
      },100)
    }else{
      setTimeout(()=>{
        this.mapService.map("rosterMap").then((map) => {
          this.primaryMap = map;
        })
      },100)
    }
  }
  getRouteList(transitMode){
    this.api.transportMangerRouteList({}).then((res:any)=>{
      if(res.status == 'success'){
        if(res.data && res.data.length>0){
          let filObj=[];
          if(transitMode=='Pickup'){
            filObj=res.data.filter(e=>e.title=="Login");
          }else if(transitMode=='Drop'){
            filObj=res.data.filter(e=>e.title=="Logout");
          }
          if(filObj && filObj[0] && filObj[0].routeID){
            this.routeId=filObj[0].routeID;
          }else{
            this.showNoData=true;
          }
        }
        this.getAssignedList(transitMode);
      }
    })
  }
  getAssignedList(transitMode){
    this.tableData={};
    let obj={
      "transitMode": transitMode,
      "tripDate": new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
      "assigned": true,
      "routeID": this.routeId
    }
    this.api.transportManagerRosterList(obj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res.data && res.data.length > 0) {
          this.responseData=res.data;
          this.findShifts(this.responseData);
          this.findVehicles(this.responseData);
          this.findEmployees(this.responseData);
          this.newFormatObjCreate(this.responseData);
        }else{
          this.showNoData=true;
        }
      }else{
        this.showNoData=true;
      }
    }).catch((err) => {
      console.log(err);
    })
  }
  newFormatObjCreate(data){
    data=this.toReqOrderByETA(data);
    if(data.length>0){
      this.showNoData=false;
      this.finalTableData={};
      for(let i=0;i<data.length;i++){
        if(this.finalTableData[data[i].shiftTime]){
          if(this.finalTableData[data[i].shiftTime][data[i].vehRegNo]){
            if(this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress]){
              this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress].push(data[i]);
            }else{
              this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress]=[];
              this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress].push(data[i]);
            }
          }else{
            this.finalTableData[data[i].shiftTime][data[i].vehRegNo]={};
            if(this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress]){
              this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress].push(data[i]);
            }else{
              this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress]=[];
              this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress].push(data[i]);
            }
          }
        }else{
          this.finalTableData[data[i].shiftTime]={};
          if(this.finalTableData[data[i].shiftTime][data[i].vehRegNo]){
            if(this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress]){
              this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress].push(data[i]);
            }else{
              this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress]=[];
              this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress].push(data[i]);
            }
          }else{
            this.finalTableData[data[i].shiftTime][data[i].vehRegNo]={};
            if(this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress]){
              this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress].push(data[i]);
            }else{
              this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress]=[];
              this.finalTableData[data[i].shiftTime][data[i].vehRegNo][data[i].empAddress].push(data[i]);
            }
          }
        }
      }
      
      let shiftArr=Object.keys(this.finalTableData).sort();
      for(let i=0;i<shiftArr.length;i++){
        let vehArr=Object.keys(this.finalTableData[shiftArr[i]]);
        for(let j=0;j<vehArr.length;j++){
          let areaArr=Object.keys(this.finalTableData[shiftArr[i]][vehArr[j]]);
          let vehCount=0;
          for(let k=0;k<areaArr.length;k++){
            this.finalTableData[shiftArr[i]][vehArr[j]][areaArr[k]]=this.finalTableData[shiftArr[i]][vehArr[j]][areaArr[k]];
            vehCount=vehCount+this.finalTableData[shiftArr[i]][vehArr[j]][areaArr[k]].length;
          }
          this.finalTableData[shiftArr[i]][vehArr[j]]['pickups']=Object.keys(this.finalTableData[shiftArr[i]][vehArr[j]]);
          this.finalTableData[shiftArr[i]][vehArr[j]].vehCount=vehCount+1;
        }
      }
      for(let i=0;i<shiftArr.length;i++){
        let vehArr=Object.keys(this.finalTableData[shiftArr[i]]);
        let shiftCount=0;
        for(let j=0;j<vehArr.length;j++){
          shiftCount=shiftCount+this.finalTableData[shiftArr[i]][vehArr[j]]['vehCount'];
        }
        this.finalTableData[shiftArr[i]]['shiftCount']=shiftCount;
        this.finalTableData[shiftArr[i]]['vehicles']=vehArr;
      }

      let shifts=Object.keys(this.finalTableData).sort();
      let vehicles=Object.keys(this.finalTableData[shifts[0]]);
      
      this.toAddDistDur(this.finalTableData);

        setTimeout(()=>{
          this.customiseArrForRoutePlot(this.finalTableData[shifts[0]],vehicles[0]);
        },1000)
    }else{
      this.showNoData=true;
    }
  }
  toReqOrderByETA(arr){
    let newArr = arr.sort(
      (p1, p2) => (p1.eta > p2.eta) ? 1 : (p1.eta < p2.eta) ? -1 : 0);
    return newArr;
  }
  changeByEta(arr){
    let newArr=[];
    for(let i=0;i<arr.length;i++){
      let x=arr[i].split(':').join('.');
      newArr.push(x);
    }
    let reqArr = newArr.sort();
    let finalArr=[];
    for(let i=0;i<reqArr.length;i++){
      let x=reqArr[i].split('.').join(':');
      finalArr.push(x);
    }
    return finalArr;
  }
  async toAddDistDur(data){
    let shiftArr=this.changeByEta(Object.keys(data));
    for(let i=0;i<shiftArr.length;i++){
      let vehArr=Object.keys(data[shiftArr[i]]);
      for(let j=0;j<vehArr.length;j++){
        if(vehArr[j]!="shiftCount" && vehArr[j]!="vehicles"){
          let areaArr=Object.keys(data[shiftArr[i]][vehArr[j]]);
          let total = { eta: 0, distance: 0 };
          let empDetails=data[shiftArr[i]][vehArr[j]];
          let area=empDetails['pickups'];
          let travelEtaDist:any = { 'eta': 0, 'distance': 0 };
          for(let k=0;k<areaArr.length-1;k++){
            for(let a=0;a<area.length;a++){
              let singleEmpEtaDist:any = { 'eta': 0, 'distance': 0 };
              if(area[a]==areaArr[k]){
                if(this.selectedTrinsitMode=='Pickup'){
                  if(a==empDetails[area[a]].length-1 && a!=0){
                    if(empDetails[area[a]][0]['branchInfo'] && empDetails[area[a]][0]['branchInfo']['location'] && empDetails[area[a]][0]['branchInfo']['location']['lat'] && empDetails[area[a]][0]['branchInfo']['location']['lng'] && empDetails[area[a]][0]['empLocation'] && empDetails[area[a]][0]['empLocation']['lat'] && empDetails[area[a]][0]['empLocation']['lng']){
                      travelEtaDist = await this.routeservice.findETADist(empDetails[area[a]][0]['empLocation'],empDetails[area[a]][0]['branchInfo']['location']).catch((err)=>console.log(err));
                    }
                  }else if(a>0){
                    if(empDetails[area[a]][0]['empLocation'] && empDetails[area[a]][0]['empLocation']['lat'] && empDetails[area[a]][0]['empLocation']['lng'] && empDetails[area[a-1]][0]['empLocation'] && empDetails[area[a-1]][0]['empLocation']['lat'] && empDetails[area[a-1]][0]['empLocation']['lng']){
                      travelEtaDist = await this.routeservice.findETADist(empDetails[area[a-1]][0]['empLocation'],empDetails[area[a]][0]['empLocation']).catch((err)=>console.log(err));
                    }
                  }else{
                    if(empDetails[area[a]][0]['branchInfo'] && empDetails[area[a]][0]['branchInfo']['location'] && empDetails[area[a]][0]['branchInfo']['location']['lat'] && empDetails[area[a]][0]['branchInfo']['location']['lng'] && empDetails[area[a]][0]['empLocation'] && empDetails[area[a]][0]['empLocation']['lat'] && empDetails[area[a]][0]['empLocation']['lng']){
                      singleEmpEtaDist = await this.routeservice.findETADist(empDetails[area[a]][0]['empLocation'],empDetails[area[a]][0]['branchInfo']['location']).catch((err)=>console.log(err));
                    }
                  }
                }else if(this.selectedTrinsitMode=='Drop'){
                  if(a==0){
                    if(empDetails[area[a]][0]['branchInfo'] && empDetails[area[a]][0]['branchInfo']['location'] && empDetails[area[a]][0]['branchInfo']['location']['lat'] && empDetails[area[a]][0]['branchInfo']['location']['lng'] && empDetails[area[a]][0]['empLocation'] && empDetails[area[a]][0]['empLocation']['lat'] && empDetails[area[a]][0]['empLocation']['lng']){
                      travelEtaDist = await this.routeservice.findETADist(empDetails[area[a]][0]['branchInfo']['location'],empDetails[area[a]][0]['empLocation']).catch((err)=>console.log(err));             
                    }
                  }else{
                    if(empDetails[area[a]][0]['empLocation'] && empDetails[area[a]][0]['empLocation']['lat'] && empDetails[area[a]][0]['empLocation']['lng'] && empDetails[area[a-1]][0]['empLocation'] && empDetails[area[a-1]][0]['empLocation']['lat'] && empDetails[area[a-1]][0]['empLocation']['lng']){
      
                      travelEtaDist = await this.routeservice.findETADist(empDetails[area[a-1]][0]['empLocation'],empDetails[area[a]][0]['empLocation']).catch((err)=>console.log(err));
                    }
                  }
                }
                let etaTime:any = await this.routeservice.convertMinsToHrsMins(travelEtaDist['eta']).catch((err)=>console.log(err));
                total['eta'] += travelEtaDist['eta'];
                total['distance'] += travelEtaDist['distance'];
                if(a==empDetails[area[a]].length-1 && a!=0){
                  total['eta'] += travelEtaDist['eta'];
                  total['distance'] += travelEtaDist['distance'];
                }else{
                  if(this.selectedTrinsitMode=='Pickup'){
                    if(singleEmpEtaDist['eta'] && singleEmpEtaDist['distance']){
                      total['eta'] += singleEmpEtaDist['eta'];
                      total['distance'] += singleEmpEtaDist['distance'];
                    }
                  }
                }
                empDetails[area[a]][0]['travelEta'] = this.getEtaTime(etaTime,'.');
                empDetails[area[a]][0]['travelDist'] = travelEtaDist['distance'];
                let totalEta = await this.routeservice.convertMinsToHrsMins(total['eta']).catch((e)=>{throw e});
                empDetails[area[a]][0]['totalEta'] = this.getEtaTime(totalEta,'.');
                empDetails[area[a]][0]['totalDistance'] = total['distance'];
                empDetails['totalEta'] = empDetails[area[a]][0]['totalEta'];
                empDetails['totalDistance'] = empDetails[area[a]][0]['totalDistance'];
              }
            }
          }
        }
      }
    }
  }
  customiseArrForRoutePlot(data,vehicle){
    let arr=[];
    let vehicleArr=Object.keys(data);
    for(let i=0;i<vehicleArr.length;i++){
      if(vehicleArr[i]!='shiftCount' && vehicleArr[i]!="vehicles" && vehicleArr[i]==vehicle){
        let pickupArr=Object.keys(data[vehicleArr[i]]);
        for(let j=0;j<pickupArr.length;j++){
          if(pickupArr[j]!='vehCount' && pickupArr[j]!='pickups' && pickupArr[j]!='totalDistance' && pickupArr[j]!='totalEta'){
            data[vehicleArr[i]][pickupArr[j]][0]['empList']=[];
            data[vehicleArr[i]][pickupArr[j]][0]['stop']=j+1;
            for(let k=0;k<data[vehicleArr[i]][pickupArr[j]].length;k++){
              data[vehicleArr[i]][pickupArr[j]][0]['empList'].push(data[vehicleArr[i]][pickupArr[j]][k].empName)
            }
            arr.push(data[vehicleArr[i]][pickupArr[j]][0])
          }
        }
      }
    }
    arr=this.toReqOrderByETA(arr);
    if(this.selectedMap=='google'){
      this.placeMarker(arr);
    }else{
      this.drawLine(arr);
    }
  }
  showRoute(shift:any,vehicle:any,pickup:any,data:any,empData){
    this.rosterMapHeight = '100%';
    this.customiseArrForRoutePlot(data,vehicle);
    if(this.isSingleEmpShow){
      this.showEmpDetail=true;
      this.rosterMapHeight = '57.5vh';
      this.showEmpData(empData);
    }
  }

  getEtaTime(eta,splitBy=':'){
    eta = ''+eta;
    let hr = eta.split(splitBy)[0];
    let min = eta.split(splitBy)[1];
    let result = `${hr} hr ${min} mins`;
    return result; 
  }

  getEtaDifference(first,second){
    let firstHr = first.split(":")[0];
    let firstMin = first.split(":")[1];
    let secondHr = second.split(":")[0];
    let secondMin = second.split(":")[1];
    let finalDateTime = new Date().setHours(Number(firstHr) - Number(secondHr), Number(firstMin) - Number(secondMin));
    let result = `${this.com.pad(new Date(finalDateTime).getHours())} hr ${this.com.pad(new Date(finalDateTime).getMinutes())} mins`;
    return result;
  }

  findShifts(data){
    let shift=[];
    for(let i=0;i<data.length;i++){
      shift.push(data[i].shiftTime);
    }
    this.shiftList=this.removeDuplicates(shift);
    let convertedShift=[];
    for(let i=0;i<this.shiftList.length;i++){
      this.shiftList[i]=this.shiftList[i].split(':').join('.');
      convertedShift.push(this.shiftList[i]);
    }
    convertedShift.sort((a, b) => a.localeCompare(b, undefined, {numeric: true}));
    this.shiftList=[];
    for(let i=0;i<convertedShift.length;i++){
      convertedShift[i]=convertedShift[i].split('.').join(':');
      this.shiftList.push(convertedShift[i]);
    }
    // this.fieldChange('','shiftOnPageLoad')
  }
  findVehicles(data){
    let vehicle=[];
    for(let i=0;i<data.length;i++){
      vehicle.push(data[i].vehRegNo);
    }
    this.vehicleList=this.removeDuplicates(vehicle);
  }
  findEmployees(data){
    let employee=[];
    for(let i=0;i<data.length;i++){
      employee.push(data[i].empName);
    }
    this.employeeList=this.removeDuplicates(employee);
  }
  removeDuplicates(arr) {
    return arr.filter((item,
        index) => arr.indexOf(item) === index);
  }
  showEmpData(obj){
    this.selectedEmpDetails=[obj];
    setTimeout(()=>{
      this.focusOnSingle(obj);
    },4000)
  }
  closeEmpDetails(){
    if(this.selectedMap=='google'){
      if(this.gglEmpMarker){
        this.gglEmpMarker.setMap(null);
      }
      this.googleMapObj.setZoom(10);
    }else{
      this.primaryMap.removeMarkerAll();
      this.osrmMarkers=[];
    }
    this.isSingleEmpShow=false;
    this.showEmpDetail=false;
    this.rosterMapHeight = '100%';
    let shifts=Object.keys(this.finalTableData).sort();
    let vehicles=Object.keys(this.finalTableData[shifts[0]]);
      setTimeout(()=>{
        this.customiseArrForRoutePlot(this.finalTableData[shifts[0]],vehicles[0]);
      },1000)
  }
  focusOnSingle(data){
    if(this.selectedMap=='google'){
      let myLatlng = new google.maps.LatLng(data.empLocation['lat'], data.empLocation['lng']);
      this.googleMapObj.setZoom(15);
      this.googleMapObj.panTo(myLatlng)
    }else{
      this.focus({'lat':data.empLocation.lat,'lng':data.empLocation.lng})
    }
    this.isSingleEmpShow=false;
  }
  placeMarker(pickLocs) {
    if(this.gglEmpMarker){
      this.gglEmpMarker.setMap(null);
    }
    if(this.globalGoogleMarker.length>0){
      for(let i=0;i<this.globalGoogleMarker.length;i++){
        this.globalGoogleMarker[i].setMap(null);
      }
    }
    this.globalGoogleMarker=[];
    let formattedLocs = pickLocs.map((e) => {
      return [e.empLocation.lat, e.empLocation.lng, { title: (e.empLocation.name?e.empLocation.name:'') }];
    });
    if(this.selectedTrinsitMode=='Pickup'){
      formattedLocs.push([pickLocs[0].branchInfo.location.lat, pickLocs[0].branchInfo.location.lng, { title: pickLocs[0].branchInfo.location.name }]);
    }else if(this.selectedTrinsitMode=='Drop'){
      formattedLocs.unshift([pickLocs[0].branchInfo.location.lat, pickLocs[0].branchInfo.location.lng, { title: pickLocs[0].branchInfo.location.name }]);
    }
    let image = {
      url : "https://maps.google.com/mapfiles/ms/icons/purple-dot.png"
    }
    for(let i=0;i<formattedLocs.length;i++){
    let myLatlng = new google.maps.LatLng(formattedLocs[i][0], formattedLocs[i][1]);
    if(this.selectedTrinsitMode=='Pickup'){
      if(i==formattedLocs.length-1){
        this.globalGoogleMarker.push(new google.maps.Marker({
          position: myLatlng, 
          map: this.googleMapObj,
        }));
      }else{
        this.globalGoogleMarker.push(new google.maps.Marker({
          position: myLatlng, 
          map: this.googleMapObj,
          icon: image
        }));
      }
    }else if(this.selectedTrinsitMode=='Drop'){
      if(i==0){
        this.globalGoogleMarker.push(new google.maps.Marker({
          position: myLatlng, 
          map: this.googleMapObj,
        }));
      }else{
        this.globalGoogleMarker.push(new google.maps.Marker({
          position: myLatlng, 
          map: this.googleMapObj,
          icon: image
        }));
      }
    }
  }
    let infoWindowContent;
    let infowindow;
    let filVal;
    for(let j=0;j<this.globalGoogleMarker.length;j++){
        this.globalGoogleMarker[j].addListener('click',(e)=>{
            if(infowindow) infowindow.close();
            filVal=pickLocs.filter(obj=> e.latLng.lat() == obj.empLocation.lat && e.latLng.lng() == obj.empLocation.lng);
            if(filVal.length>0){
              if(this.selectedTrinsitMode=='Pickup'){
                infoWindowContent = '<div class="window-content-container"><span><i class="fa fa-user" aria-hidden="true" style="color:rgb(76,125,254)"></i></span><span style="font-weight:700" class="ml-1">' + (filVal[0]['empList']?this.convertToUpperCase(filVal[0]['empList']):'---') + '</span><div style="margin-top:4px">'+'ETA :'+'<span>'+' '+(filVal[0].etaStr?filVal[0].etaStr:'---')+'</span></div><div style="margin-top:2px">'+'Pickup Point :'+'<span>'+' '+(filVal[0].stop?filVal[0].stop:'---')+'</span></div><div style="margin-top:2px">'+'Vehicle :'+'<span>'+' '+ (filVal[0].vehRegNo?filVal[0].vehRegNo.toUpperCase():'---') +'</span></div></div>';
              }else if(this.selectedTrinsitMode=='Drop'){
                infoWindowContent = '<div class="window-content-container"><span><i class="fa fa-user" aria-hidden="true" style="color:rgb(76,125,254)"></i></span><span style="font-weight:700" class="ml-1">' + (filVal[0]['empList']?this.convertToUpperCase(filVal[0]['empList']):'---') + '</span><div style="margin-top:4px">'+'ETA :'+'<span>'+' '+(filVal[0].etaStr?filVal[0].etaStr:'---')+'</span></div><div style="margin-top:2px">'+'Drop Point :'+'<span>'+' '+(filVal[0].stop?filVal[0].stop:'---')+'</span></div><div style="margin-top:2px">'+'Vehicle :'+'<span>'+' '+ (filVal[0].vehRegNo?filVal[0].vehRegNo.toUpperCase():'---') +'</span></div></div>';
              }
            }
            if(filVal.length==0){
              filVal=pickLocs.filter(obj=> e.latLng.lat() == obj.branchInfo.location.lat && e.latLng.lng() == obj.branchInfo.location.lng);
              if(filVal.length>0){
                infoWindowContent = '<div class="window-content-container"><span><i class="fa fa-building" aria-hidden="true" style="color:rgb(76,125,254)"></i><span style="font-weight:700;position:relative;top:1px" class="ml-1">' + filVal[0].branchInfo.name + '</span></div>';
              }
            }
              infowindow = new google.maps.InfoWindow({
                  content: infoWindowContent
              });
            this.googleMapObj.setZoom(15);
            this.googleMapObj.panTo(this.globalGoogleMarker[j].position);
        })
        this.googleMapObj.setZoom(10);
              this.googleMapObj.panTo(this.globalGoogleMarker[0].position);
        google.maps.event.addListener(this.globalGoogleMarker[j], 'click', function() {
            infowindow.open(this.googleMapObj, this);
        });
    }
    this.plotRoute(formattedLocs);
  }
  async plotRoute(locs){
    if(this.routePath){
      this.routePath.setMap(null);
    }
    let wayPointsLocations:any;
    wayPointsLocations = await this.routeservice.findWayPoints(locs);
    let position={};
      let location=[];
      for(let i=0;i<wayPointsLocations.length;i++){
        position={
          lat : +wayPointsLocations[i][0],
          lng : +wayPointsLocations[i][1],
        }
        location.push(position);
      }
      this.routePath = new google.maps.Polyline({
        path: location,
        geodesic: true,
        strokeColor: "#444",
        strokeOpacity: 1.0,
        strokeWeight: 2,
      })
      this.routePath.setMap(this.googleMapObj);
  }
  focus(e) {
    const obj = {
      lat: e.lat,
      lng: e.lng,
      zoom: 13
    };
    this.primaryMap.focus(obj);
  }
  async drawLine(data) {
    let pickLocs = data.sort(
      (p1, p2) => (p1.eta > p2.eta) ? 1 : (p1.eta < p2.eta) ? -1 : 0);
    let formattedLocs = pickLocs.map((e) => {
      return [e.empLocation.lat, e.empLocation.lng, { title: e.empLocation.name }];
    });
    if(this.selectedTrinsitMode=='Pickup'){
      formattedLocs.push([data[0].branchInfo.location.lat, data[0].branchInfo.location.lng, { title: data[0].branchInfo.location.name }]);
    }else if(this.selectedTrinsitMode=='Drop'){
      formattedLocs.unshift([data[0].branchInfo.location.lat, data[0].branchInfo.location.lng, { title: data[0].branchInfo.location.name }]);
    }
    let wayPointsLocations = await this.routeservice.findWayPoints(formattedLocs);
    setTimeout(() => {
        this.primaryMap.addLine({
            id: 'rosterMapLine',
            locations: wayPointsLocations,
            color: '#444',
            width: 2,
            animation: false,
            bearingFocus: true,
        });
        this.createOsrmMarker(formattedLocs,data);
    }, 2000)
  }
  convertToUpperCase(arr){
    let newArr=[];
    for(let i=0;i<arr.length;i++){
      newArr.push(this.com.convertTitleCase(arr[i]))
    }
    return newArr;
  }
  createOsrmMarker(locs,data) {
    let markers=[];
    for(let i=0;i<locs.length;i++){
      let eMarker={};
      if(this.selectedTrinsitMode=='Pickup'){
        if(i==locs.length-1){
          eMarker = {
            id: 'rosterMarker'+ Math.round(Math.random() * 10000),
            content: '<div class="mumb_marker_pin" style="background: red;"></div><div class="mumb_marker_pulse" style="background: red;"></div><div class="mumb_marker_marker-label osrmMarkerInfo" style="top:-33px;left:-7px"><span><i class="fa fa-building" aria-hidden="true" style="color:rgb(76,125,254)"></i><span style="font-weight:700;position:relative;top:1px" class="ml-1">' + (data[0].branchInfo.name?this.com.convertTitleCase(data[0].branchInfo.name):'---') + '</span></div>',
            lat: locs[i][0],
            lng: locs[i][1]
          };
        }else{
          eMarker = {
            id: 'rosterMarker'+ Math.round(Math.random() * 10000),
            content: '<div class="mumb_marker_pin" style="background: rgb(98,100,167);"></div><div class="mumb_marker_pulse" style="background: rgb(98,100,167);"></div><div class="mumb_marker_marker-label osrmMarkerInfo" style="padding:0px 5px 0px 5px;text-align:start;top:-65px;left:-7px"><span><i class="fa fa-user" aria-hidden="true" style="color:rgb(76,125,254)"></i></span><span style="font-weight:700" class="ml-1">' + (data[i]['empList']?this.convertToUpperCase(data[i]['empList']):'---') + '</span><div>'+'ETA :'+'<span>'+' '+(data[i].etaStr?data[i].etaStr:'---')+'</span></div><div>'+'Pickup Point :'+'<span>'+' '+(data[i].stop?data[i].stop:'---')+'</span></div><div>'+'Vehicle :'+'<span>'+' '+ (data[i].vehRegNo?data[i].vehRegNo.toUpperCase():'---') +'</span></div></div>',
            lat: locs[i][0],
            lng: locs[i][1]
          };
        }
        let focusObj = {
          lat: locs[i][0],
          lng: locs[i][1],
          zoom: 10
        };
        this.primaryMap.focus(focusObj);
      }else if(this.selectedTrinsitMode=='Drop'){
        if(i==0){
          eMarker = {
            id: 'rosterMarker'+ Math.round(Math.random() * 10000),
            content: '<div class="mumb_marker_pin" style="background: red;"></div><div class="mumb_marker_pulse" style="background: red;"></div><div class="mumb_marker_marker-label osrmMarkerInfo" style="top:-33px;left:-7px"><span><i class="fa fa-building" aria-hidden="true" style="color:rgb(76,125,254)"></i><span style="font-weight:700;position:relative;top:1px" class="ml-1">' + (data[0].branchInfo.name?this.com.convertTitleCase(data[0].branchInfo.name):'---') + '</span></div>',
            lat: locs[i][0],
            lng: locs[i][1]
          };
        }else{
          eMarker = {
            id: 'rosterMarker'+ Math.round(Math.random() * 10000),
            content: '<div class="mumb_marker_pin" style="background: rgb(98,100,167);"></div><div class="mumb_marker_pulse" style="background: rgb(98,100,167);"></div><div class="mumb_marker_marker-label osrmMarkerInfo" style="padding:0px 5px 0px 5px;text-align:start;top:-65px;left:-7px"><span><i class="fa fa-user" aria-hidden="true" style="color:rgb(76,125,254)"></i></span><span style="font-weight:700" class="ml-1">' + (data[i-1]['empList']?this.convertToUpperCase(data[i-1]['empList']):'---') + '</span><div>'+'ETA :'+'<span>'+' '+(data[i-1].etaStr?data[i-1].etaStr:'---')+'</span></div><div>'+'Drop Point :'+'<span>'+' '+(data[i-1].stop?data[i-1].stop:'---')+'</span></div><div>'+'Vehicle :'+'<span>'+' '+ (data[i-1].vehRegNo?data[i-1].vehRegNo.toUpperCase():'---') +'</span></div></div>',
            lat: locs[i][0],
            lng: locs[i][1]
          };
        }
        let focusObj = {
          lat: locs[0][0],
          lng: locs[0][1],
          zoom: 10
        };
        this.primaryMap.focus(focusObj);
      }
      markers.push(eMarker);
    }
    this.primaryMap.onClick({
      type: 'marker',
    }, (e: any) => {
      this.primaryMap.focus({
        lat: e._lngLat.lat,
        lng: e._lngLat.lng,
        zoom: 15
      });
      this.primaryMap.onMapZoom((z) => {
        let parent=this;
        if (z >= 15) {
          if (parent.osrmMarkerInfoStyle == 'hidden') {
            const osrmMarkerInfo = document.querySelectorAll('.osrmMarkerInfo');
            for (let i = 0; i < osrmMarkerInfo.length; i++) {
              const elem: any = osrmMarkerInfo[i];
              elem.style.visibility = 'visible';
            }
            parent.osrmMarkerInfoStyle = 'visible';
          }
        }
        else {
          if (parent.osrmMarkerInfoStyle == 'visible') {
            const osrmMarkerInfo = document.querySelectorAll('.osrmMarkerInfo');
            for (let i = 0; i < osrmMarkerInfo.length; i++) {
              const elem: any = osrmMarkerInfo[i];
              elem.style.visibility = 'hidden';
            }
            parent.osrmMarkerInfoStyle = 'hidden';
          }
        }
      });
    });
    this.primaryMap.removeMarkerAll();
    this.primaryMap.addMarkers(markers);
  }
  fieldChange(e,field){
    if(this.selectedMap=='google'){
      if(this.globalGoogleMarker.length>0){
        for(let i=0;i<this.globalGoogleMarker.length;i++){
          this.globalGoogleMarker[i].setMap(null);
        }
      }
      this.globalGoogleMarker=[];
      if(this.routePath){
        this.routePath.setMap(null);
      }
      if(this.gglEmpMarker){
        this.gglEmpMarker.setMap(null);
      }
    }else{
      this.primaryMap.removeMarkerAll();
      this.osrmMarkers=[];
    }
    let value = e.target.value;
    if(field=='shift'){
      this.selectedShift=value;
    }
    if(field=='vehicle'){
      this.selectedVehicle=value;
    }
    if(field=='employee'){
      this.selectedEmployee=value;
    }
    let data=[];
    if(this.selectedShift!='' && this.selectedVehicle!='' && this.selectedEmployee!=''){
      data=this.responseData.filter(e=>e.shiftTime == this.selectedShift && e.vehRegNo == this.selectedVehicle && e.empName == this.selectedEmployee)
    }else if(this.selectedShift!='' && this.selectedVehicle!='' && this.selectedEmployee==''){
      data=this.responseData.filter(e=>e.shiftTime == this.selectedShift && e.vehRegNo == this.selectedVehicle)
    }else if(this.selectedShift!='' && this.selectedVehicle=='' && this.selectedEmployee!=''){
      data=this.responseData.filter(e=>e.shiftTime == this.selectedShift && e.empName == this.selectedEmployee)
    }else if(this.selectedShift=='' && this.selectedVehicle!='' && this.selectedEmployee!=''){
      data=this.responseData.filter(e=>e.vehRegNo == this.selectedVehicle && e.empName == this.selectedEmployee)
    }else if(this.selectedShift!='' && this.selectedVehicle=='' && this.selectedEmployee==''){
      data=this.responseData.filter(e=>e.shiftTime == this.selectedShift)
    }else if(this.selectedShift=='' && this.selectedVehicle=='' && this.selectedEmployee!=''){
      data=this.responseData.filter(e=>e.empName == this.selectedEmployee)
    }else if(this.selectedShift=='' && this.selectedVehicle!='' && this.selectedEmployee==''){
      data=this.responseData.filter(e=>e.vehRegNo == this.selectedVehicle)
    }else{
      data=this.responseData;
    }
    if(field!='transitMode'){
      if(this.selectedMap!='google'){
        if(data.length==0){
          this.primaryMap.removeLineAll();
        }
      }
      this.newFormatObjCreate(data);
    }

    if(field=='transitMode'){
      this.shiftList=[];
      this.employeeList=[];
      this.vehicleList=[];
      this.selectedTrinsitMode=value;
      this.selectedShift='';
      this.selectedVehicle='';
      this.selectedEmployee='';
      this.getRouteList(value);
    }
    this.showEmpDetail=false;
    this.rosterMapHeight = '76vh';
  }
}
